import { render, staticRenderFns } from "./RssFeed.vue?vue&type=template&id=49751d96&scoped=true"
import script from "./RssFeed.vue?vue&type=script&lang=js"
export * from "./RssFeed.vue?vue&type=script&lang=js"
import style0 from "./RssFeed.vue?vue&type=style&index=0&id=49751d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49751d96",
  null
  
)

export default component.exports